import { globalConstants } from "../constants";
import {
  getRequest,
  putRequest,
  postRequest,
  deleteRequest,
  postRequestWithFiles,
  putRequestWithFiles,
} from "../system/server-call";
import responseHandler from "../system/server-response-handler";

async function getPublicCompetitions(gridData) {
  return postRequest(
    `/${globalConstants.VERSION}/Competition/get/view`,
    gridData,
    true
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}

async function getPublicCompetitionById(id) {
  return getRequest(`/${globalConstants.VERSION}/Competition/${id}`).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}

async function getCompetitions(gridData) {
  return postRequest(
    `/${globalConstants.VERSION}/Competition/get`,
    gridData,
    true
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}

async function getCompetitionById(id) {
  return getRequest(`/${globalConstants.VERSION}/Competition/docs/${id}`).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}

async function addCompetition(competitionData) {
  return postRequestWithFiles(
    `/${globalConstants.VERSION}/Competition`,
    competitionData,
    true
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}

async function updateCompetition(competitionData) {
  return putRequestWithFiles(
    `/${globalConstants.VERSION}/Competition`,
    competitionData,
    true
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}

async function updateCompetitionStatusById(id, status) {
  return putRequest(
    `/${globalConstants.VERSION}/Competition/updateStatus/${id}/${status}`,
    true
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}

async function deleteCompetitionById(id) {
  return deleteRequest(`/${globalConstants.VERSION}/Competition/${id}`).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}
async function getCompetitionParticipantsById(id, gridData) {
  return postRequest(
    `/${globalConstants.VERSION}/CompetitionParticipant/participants/${id}`,
    gridData,
    true
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}

async function getCompetitionGeneralDetailById(id) {
  return getRequest(`/${globalConstants.VERSION}/Competition/${id}`).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}
async function getCompetitionStats(id) {
  return getRequest(`/${globalConstants.VERSION}/Competition/stats/${id}`).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}
async function cancelParticipants(id) {
  return deleteRequest(
    `/${globalConstants.VERSION}/CompetitionParticipant/cancel/${id}`
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}

async function getParticipantByEmail(email) {
  return postRequest(
    `/${globalConstants.VERSION}/User/student`,
    email,
    true
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}

async function publishScore(id) {
  return postRequest(
    `/${globalConstants.VERSION}/Competition/publishScore/${id}`,
    true
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}

async function addParticipant(data) {
  return postRequest(
    `/${globalConstants.VERSION}/CompetitionParticipant/register`,
    data,
    true
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}

async function addParticipantWithPayment(checkoutId, boatClassId) {
  return postRequest(
    `/${globalConstants.VERSION}/CompetitionParticipant/register/${checkoutId}/${boatClassId}`,
    true
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}

async function download(competitionId, gridData) {
  return postRequest(
    `/${globalConstants.VERSION}/CompetitionParticipant/export/participants/${competitionId}`,
    gridData,
    true
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}

async function updateScore(competitionId, data) {
  return postRequest(
    `/${globalConstants.VERSION}/CompetitionParticipant/updateScore/${competitionId}`,
    data,
    true
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}

async function uploadFiles(competitionData) {
  return postRequestWithFiles(
    `/${globalConstants.VERSION}/Competition/result`,
    competitionData,
    true
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}

async function getUploadedFile(competitionId) {
  return getRequest(
    `/${globalConstants.VERSION}/Competition/result/${competitionId}`
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}

const cancelRegistrationPublic = (systemUserId, competitionId) => {
  return deleteRequest(
    `/${globalConstants.VERSION}/CompetitionParticipant/public/cancel/${systemUserId}/${competitionId}`
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

const cancelRegistrationPrivate = (systemUserId, competitionId) => {
  return deleteRequest(
    `/${globalConstants.VERSION}/CompetitionParticipant/private/cancel/${systemUserId}/${competitionId}`
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

const validateParticipentsForCompetition = (systemUserId, competitionId) => {
  return getRequest(
    `/${globalConstants.VERSION}/CompetitionParticipant/validate/${systemUserId}/${competitionId}`
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};
async function getMyCompetitions(gridData, userId) {
  return postRequest(
    `/${globalConstants.VERSION}/Competition/user/${userId}`,
    gridData,
    true
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}
async function getCompetitionQuestion(token) {
  return getRequest(
    `/${globalConstants.VERSION}/Feedback/questions/competition`,
    true,
    null
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}
async function getCompetitionDetailResult(id) {
  return getRequest(
    `/${globalConstants.VERSION}/Competition/result/${id}`
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}

async function refundPublicCompetition(data) {
  return postRequest(
    `/${globalConstants.VERSION}/CompetitionParticipant/admin/public/cancel`,
    data,
    true
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}
async function saveCompetitionFeedback(data, token) {
  return postRequest(
    `/${globalConstants.VERSION}/feedback/feedbackResponse/competition/${token}`,
    data,
    true,
    null
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}

async function getCompetitionFeedbackById(id) {
  return getRequest(
    `/${globalConstants.VERSION}/Feedback/competition/${id}`
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}

const competitionRegistrationwithSavedCard = (data) => {
  return postRequest(
    `/${globalConstants.VERSION}/CompetitionParticipant/savedCard/register`,
    data
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

async function getCompetitionTotalPaymentById(competitionId) {
  return getRequest(
    `/${globalConstants.VERSION}/Competition/totalPayment/${competitionId}`
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}

async function getCompetitionLeaderboardBoatClasses(id) {
  return getRequest(
    `/${globalConstants.VERSION}/Competition/genderBoatClass/filter/${id}`,
    true
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}

export const competitionService = {
  getPublicCompetitions,
  getPublicCompetitionById,
  getCompetitions,
  getCompetitionById,
  addCompetition,
  updateCompetition,
  updateCompetitionStatusById,
  deleteCompetitionById,
  getMyCompetitions,
  validateParticipentsForCompetition,
  cancelRegistrationPublic,
  cancelRegistrationPrivate,
  getCompetitionParticipantsById,
  getCompetitionGeneralDetailById,
  cancelParticipants,
  publishScore,
  getParticipantByEmail,
  addParticipant,
  addParticipantWithPayment,
  download,
  updateScore,
  uploadFiles,
  getUploadedFile,
  getCompetitionStats,
  getCompetitionQuestion,
  getCompetitionDetailResult,
  refundPublicCompetition,
  saveCompetitionFeedback,
  getCompetitionFeedbackById,
  competitionRegistrationwithSavedCard,
  getCompetitionTotalPaymentById,
  getCompetitionLeaderboardBoatClasses,
};
